$('.winners').click(function() {
  $(this).toggleClass('active');
  $(this).next().toggleClass('hidden');
});



// WEBPACK FOOTER //
// ./scripts/modules/winners.js